<h2 mat-dialog-title>{{ "iplexDeviceWifiSettingsDialogComponent.dialogTitle" | translate }}</h2>
<div class="container">
  <div class="form-container">
    <!--SSID-->
    <div class="form-area ssid-div">
      <mat-form-field class="settings-form">
        <mat-label>{{ "iplexDeviceWifiSettingsDialogComponent.ssid" | translate }}</mat-label>
        <input matInput [formControl]="ssidForm" [maxlength]="ssidMaxLength" />
        <mat-hint align="end">{{ ssidForm.value?.length || 0 }} / {{ ssidMaxLength }}</mat-hint>
        <mat-error *ngIf="ssidForm.hasError('required')">
          {{ "iplexDeviceWifiSettingsDialogComponent.ssidRequiredError" | translate }}
        </mat-error>
        <mat-error *ngIf="ssidForm.hasError('maxlength')">
          {{ "iplexDeviceWifiSettingsDialogComponent.ssidMaxlengthError" | translate: { maxLength: ssidMaxLength } }}
        </mat-error>
        <mat-error *ngIf="ssidForm.hasError('pattern') && !ssidForm.hasError('required') && !ssidForm.hasError('maxlength')">
          {{ "iplexDeviceWifiSettingsDialogComponent.ssidRegexError" | translate }}</mat-error
        >
      </mat-form-field>
    </div>

    <!--SECURE MODE-->
    <div class="form-area secure-mode-div">
      <mat-form-field class="settings-form">
        <mat-label>{{ "iplexDeviceWifiSettingsDialogComponent.security" | translate }}</mat-label>
        <mat-select [formControl]="securityModeForm" required (selectionChange)="setPassphrase(this.passPhraseForm.value)">
          <mat-select-trigger>
            {{ securityModeForm.value }}
          </mat-select-trigger>
          <mat-option *ngFor="let opt of securityModeOptions" [value]="opt">
            {{ opt }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--Passphrase-->
    <div class="form-area passphrese-div">
      <mat-form-field class="settings-form">
        <mat-label>{{ "iplexDeviceWifiSettingsDialogComponent.passPhrase" | translate }}</mat-label>
        <input matInput [formControl]="passPhraseForm" [maxlength]="passphraseMaxLength" [type]="isPassphraseHide ? 'password' : 'text'" />
        <mat-icon matSuffix (click)="isPassphraseHide = !isPassphraseHide">{{ isPassphraseHide ? "visibility_off" : "visibility" }}</mat-icon>
        <mat-hint align="end" *ngIf="securityModeForm.value !== 'NONE'">{{ passPhraseForm.value?.length || 0 }} / {{ passphraseMaxLength }}</mat-hint>
        <mat-error *ngIf="passPhraseForm.hasError('required')">
          {{ "iplexDeviceWifiSettingsDialogComponent.passPhraseRequiredError" | translate }}
        </mat-error>
        <mat-error *ngIf="passPhraseForm.hasError('maxlength') || passPhraseForm.hasError('minlength')">
          {{
            "iplexDeviceWifiSettingsDialogComponent.passPhraseWPALengthError"
              | translate: { maxLength: passphraseMaxLength, minLength: passphraseMinLength }
          }}
        </mat-error>
        <mat-error
          *ngIf="
            passPhraseForm.hasError('pattern') && !ssidForm.hasError('required') && !ssidForm.hasError('maxlength') && !ssidForm.hasError('minlength')
          "
        >
          {{ "iplexDeviceWifiSettingsDialogComponent.passPhraseRegexError" | translate }}</mat-error
        >
      </mat-form-field>
    </div>

    <!--Channel-->
    <div class="form-area channel-mode-div">
      <mat-form-field class="settings-form">
        <mat-label>{{ "iplexDeviceWifiSettingsDialogComponent.channel" | translate }}</mat-label>
        <mat-select [formControl]="channelForm" required>
          <mat-select-trigger>
            {{ channelForm.value }}
          </mat-select-trigger>
          <mat-option *ngFor="let opt of channelOptions" [value]="opt">
            {{ opt }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="container">
  <mat-dialog-actions class="wifi-settings-actions">
    <button mat-button color="primary" (click)="close()">
      {{ "iplexDeviceWifiSettingsDialogComponent.close" | translate }}
    </button>
    <button mat-raised-button [disabled]="hasFormError || !isChanged" color="primary" (click)="apply()">
      {{ "iplexDeviceWifiSettingsDialogComponent.save" | translate }}
    </button>
  </mat-dialog-actions>
</div>
